import React, { useEffect, useState } from "react";
import FirstLogin from "./FirstLogin";
import SecondLogin from "./SecondLogin";
import { emailHasCredentialsOnServer } from "./Server";
import { styles } from "./styles";

function App() {
  const [emailFromMerchant, setEmailFromMerchant] = useState("");
  const [hasAlreadyBioAuth, setHasAlreadyBioAuth] = useState(null);
  const [isSupported, setIsSupported] = useState(null);

  const handleLogin = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    setHasAlreadyBioAuth(emailHasCredentialsOnServer(email));
  };

  useEffect(() => {
    const isUserVerifyingPlatformAuthenticatorAvailable = async () => {
      if (window.PublicKeyCredential) {
        try {
          const isAvailable =
            await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
          return isAvailable;
        } catch (error) {
          console.error(
            "Error while checking authenticator availability:",
            error
          );
          return false;
        }
      } else {
        return Promise.resolve(false);
      }
    };

    const timeoutPromise = new Promise((resolve) => {
      setTimeout(() => {
        resolve(false); // Resolve to false after timeout
      }, 5000);
    });

    Promise.race([
      isUserVerifyingPlatformAuthenticatorAvailable(),
      timeoutPromise,
    ]).then((isSupported) => {
      if (!isSupported) {
        setIsSupported(false);
        alert(
          "Biometric authentication is not supported by this browser, or the check timed out."
        );
      } else {
        setIsSupported(true);
        // alert("Biometric authentication is supported!");
      }
    });
  }, []);

  // if (isSupported) {
  //   return <h1 style={styles.header}>Is Supported</h1>;
  // } else {
  //   return <h1 style={styles.header}>Not supported</h1>;
  // }

  useEffect(() => {
    const hasAlreadyGeneratedBioAuth = async () => {
      const challenge = new Uint8Array(32);
      console.log("foo: hasAlreadyGeneratedBioAuth");

      try {
        const credentials = await navigator.credentials.get({
          publicKey: {
            challenge,
            rpId: window.location.hostname,
            rp: {
              name: "Trustly", // The name of your application or service.
              id: window.location.hostname, // The hostname of your application. This must match the domain name where the credential is created.
            },
            mediation: "silent",
            allowCredentials: [],
          },
        });

        if (credentials) {
          console.log("foo: credentials: ", credentials);
        } else {
          console.log("foo: no credentials");
        }
      } catch (error) {
        console.error("Error checking credentials:", error);
      }
    };

    // hasAlreadyGeneratedBioAuth();
  }, []);

  if (hasAlreadyBioAuth === null) {
    return (
      <div style={styles.container}>
        <h1 style={styles.header}>
          Enter email that we would normally get from merchant
        </h1>
        <ol>
          <li>Enter any random string; for example your email</li>
          <li>Go through the flow</li>
          <li>
            Next time you enter same email / random string, you should get the
            fast flow
          </li>
        </ol>

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="text"
            name="email"
            value={emailFromMerchant}
            style={styles.input}
            onChange={(e) => setEmailFromMerchant(e.target.value.toLowerCase())}
            placeholder="Any random string / email"
          />
          <button type="submit" style={styles.button}>
            Enter
          </button>
        </form>
      </div>
    );
  }
  return hasAlreadyBioAuth ? (
    <SecondLogin email={emailFromMerchant} />
  ) : (
    <FirstLogin email={emailFromMerchant} />
  );
}

export default App;
